/* src/app/views/template/components/templates/digital/digital-product-templates/digital-product-templates.component.scss */
/*# sourceMappingURL=digital-product-templates.component.css.map */
